import { sendGAEvent } from "@next/third-parties/google";
import { fetchApiRaw } from "@/api/fetch";
import { CodeAnalysisId } from "@/api/generated/models";
import {
  getAnalyzePublicGitHubRepoUrl,
  getAnalyzePublicRepoUrl,
} from "../../generated/endpoints/analysis-controller/analysis-controller";

export const requestPublicRepoAnalysis = async (
  repoURL: string,
): Promise<{ id: number; location: string }> => {
  const response = await fetchApiRaw(getAnalyzePublicRepoUrl(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: repoURL,
  });

  const redirect = response.headers.get("Location");

  if (!redirect) {
    throw new Error("No redirect location found in response headers");
  }

  const json = (await response.json()) as CodeAnalysisId;
  const analysisId = json.value;

  if (!analysisId) {
    throw new Error("No analysis ID found in response");
  }

  return {
    id: analysisId,
    location: redirect,
  };
};
export const requestPublicGitHubRepoAnalysis = async (
  account: string,
  repo: string,
): Promise<{ id: number; location: string }> => {
  // track that the user requested an analysis
  sendGAEvent("event", "requestAnalysis", { account, repo });

  const response = await fetchApiRaw(getAnalyzePublicGitHubRepoUrl(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      account,
      repo,
    }),
  });

  const redirect = response.headers.get("Location");

  if (!redirect) {
    throw new Error("No redirect location found in response headers");
  }

  const json = (await response.json()) as CodeAnalysisId;
  const analysisId = json?.value;

  if (!analysisId) {
    throw new Error("No analysis ID found in response");
  }

  return {
    id: analysisId,
    location: redirect,
  };
};
